import { validator } from "./validator";
import { IWizardStep } from "../../../wizard/types";
import EditApplication from "./EditApplication";

export const editContentConfig: IWizardStep = {
  width: "720px",
  titleConfig: {
    titleText: "Edit",
  },
  content: EditApplication,
  validator: validator,
  stepName: "step1",
};
